import * as React from 'react';
import styled from 'styled-components';

import Text from 'crehana-ui/Text';

import getImgxUrl from 'Jsx/Utils/getImgxUrl';

import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';

const StyledTag = styled.div`
  background: rgba(0, 0, 0, 0.3);
  left: 12px;
  bottom: 12px;
  padding: 2px 8px;
`;

const BrasilianTag: React.FC<Partial<CourseCardProps>> = props => {
  if (!props.languageTag) {
    return null;
  }

  return (
    <StyledTag className="flex items-center absolute z-2 px-8 bg-base-main-80">
      <img
        alt={`curso ${props.languageTag.text}`}
        src={getImgxUrl(props.languageTag.flagImageUrl, {
          w: 20,
          h: 14,
        })}
        style={{ width: 20, height: 14 }}
        className="mr-4"
      />
      <Text type="caption" color="white">
        {props.languageTag.text}
      </Text>
    </StyledTag>
  );
};

export default BrasilianTag;
